import { render, staticRenderFns } from "./Home1.vue?vue&type=template&id=163084dc&scoped=true"
import script from "./Home1.vue?vue&type=script&lang=js"
export * from "./Home1.vue?vue&type=script&lang=js"
import style0 from "./Home1.vue?vue&type=style&index=0&id=163084dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163084dc",
  null
  
)

export default component.exports